// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-icons{max-width:330px;text-align:center}.payment-icons__list{display:flex;margin:0 -4px}.payment-icons__item{flex-grow:1;max-width:48px;margin:0 4px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
